import { Container, Text } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { BlurredGraphBackground } from "../components/BlurredGraphBackground";
import { RelatanceLockup } from "../components/Brand/RelatanceLockup";
import { useAuthCompat } from "../hooks/useAuthCompat";

export const Route = createFileRoute("/welcome")({
	component: WelcomePage,
});

function WelcomePage() {
	const { user, isLoading, signIn, signUp } = useAuthCompat();

	// Redirect authenticated users to the main app
	useEffect(() => {
		if (user && !isLoading) {
			window.location.href = "/";
		}
	}, [user, isLoading]);

	// Show loading while auth state is being determined
	if (isLoading) {
		return (
			<div className="flex items-center justify-center min-h-screen">
				<div className="text-lg" style={{ color: "var(--ink-secondary)" }}>
					Loading...
				</div>
			</div>
		);
	}

	return (
		<BlurredGraphBackground>
			<Container size="sm">
				<div className="plate flex flex-col items-center text-center gap-6">
					<RelatanceLockup />

					<span className="kicker">Invitation only</span>

					<Text
						size="lg"
						maw={420}
						style={{
							color: "var(--ink)",
							fontFamily: "var(--font-display)",
							fontWeight: 600,
							letterSpacing: "-0.02em",
							lineHeight: 1.25,
						}}
					>
						Relationship Coordination Infrastructure for the Built Environment
					</Text>

					<Text
						size="md"
						maw={420}
						style={{ color: "var(--ink-secondary)", lineHeight: 1.62 }}
					>
						Relatance is currently available only to invited pilot users. If you
						have received an invitation, you may sign in. If not, you may
						request access below.
					</Text>

					<button type="button" onClick={() => signUp()} className="btn-gold">
						Join Waitlist
					</button>

					<Text size="sm" style={{ color: "var(--ink-secondary)" }}>
						Access is granted selectively during the pilot phase.
					</Text>

					<div className="flex items-center gap-2">
						<Text size="sm" style={{ color: "var(--ink-secondary)" }}>
							Already invited?
						</Text>
						<button
							type="button"
							onClick={() => signIn()}
							className="bg-transparent border-0 cursor-pointer font-semibold"
							style={{ color: "var(--gold)", fontFamily: "var(--font-body)" }}
						>
							Sign in
						</button>
					</div>
				</div>
			</Container>
		</BlurredGraphBackground>
	);
}
